

























































































































import Vue from "vue";
import {User} from "./types";
import statusCodes from "@/config/status-codes";
import {urls} from "@/config";

export default Vue.extend({
  name: "App",
  data() {
    return {
      loading: false,
      hasExams: false,
      notIdentified: false,
      supportEmail: urls.supportEmail,
      disclaimerItems: [
        {
          item: this.$t("disclaimer.item1"),
          description: this.$t("disclaimer.itemDescription1"),
          correct: false,
          selected: false
        },
        {
          item: this.$t("disclaimer.item2"),
          description: this.$t("disclaimer.itemDescription2"),
          correct: false,
          selected: false
        },
        {
          item: this.$t("disclaimer.item3"),
          description: this.$t("disclaimer.itemDescription3"),
          correct: false,
          selected: false
        },
        {
          item: this.$t("disclaimer.item4"),
          description: this.$t("disclaimer.itemDescription4"),
          correct: false,
          selected: false
        },
        {
          item: this.$t("disclaimer.item5"),
          description: this.$t("disclaimer.itemDescription5"),
          correct: true,
          selected: false
        },
        {
          item: this.$t("disclaimer.item6"),
          description: this.$t("disclaimer.itemDescription6"),
          correct: true,
          selected: false
        }
      ],
      beforeStartExam: false,
      mobileDevice: false
    };
  },
  computed: {
    user(): User {
      return this.$store.state.user.data;
    },
    examStarted(): boolean {
      return this.$store.state.general.examStarted;
    },
    exception(): boolean {
      return this.$store.state.general.exception;
    },
    disclaimerAccepted(): boolean {
      const correctItems = this.disclaimerItems.filter((i) => i.correct).length;
      const correctSelected = this.disclaimerItems.filter((i) => i.selected && i.correct).length;
      const incorrectSelected = this.disclaimerItems.filter((i) => i.selected && !i.correct).length;

      return !incorrectSelected && correctItems === correctSelected;
    }
  },
  async mounted() {
    try {
      this.checkDevice();

      if (!this.mobileDevice) {
        this.loading = true;
        await Promise.all([
          this.$store.dispatch("general/getStatus")
        ]);
        await this.tryToGetExamsList();
        this.loading = false;
      }
    } catch (e) {
      switch (e.code) {
        case statusCodes.UNAUTHORIZED:
          window.location.href = urls.SIGN_IN;
          break;
        case statusCodes.NOT_ALLOWED:
          window.location.href = urls.SIGN_IN;
          break;
        case statusCodes.NOT_IDENTIFIED:
          this.notIdentified = true;
          break;
        default:
          Vue.set(this.$store.state.general, "exception", true);
      }
    }
  },
  methods: {
    async tryToGetExamsList() {
      if (this.examStarted) {
        await this.$store.dispatch("general/getExamsList");
        this.hasExams = Object.keys(this.$store.state.general.examsList).length !== 0;
      }
    },
    async startExam() {
      try {
        this.beforeStartExam = false;
        await this.$store.dispatch("general/startExam");
        await this.tryToGetExamsList();
        await this.$router.push({name: "programming"});
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }
    },
    clearException() {
      Vue.set(this.$store.state.general, "exception", false);
    },
    exit() {
      window.location.href = urls.SIGN_IN;
    },
    checkDevice() {
      if (Math.min(window.screen.width, window.screen.height) < 500) {
        this.mobileDevice = true;
      }
    }
  }
});
